export const getRandomBackground = () => Math.floor(Math.random() * 9) + 1;
